/* --------------------------------------------------------------------------------------
   jobStatus.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class jobStatusService {
    /*@ngInject*/
  constructor (appSettings, appService, $q, $timeout) {
    this.appSettings = appSettings
    this.appService = appService
    this.$q = $q
    this.$timeout = $timeout
  }
  getScanTransferringStatus(jobId) {
    return this.getTransferringStatus(jobId, "WorkflowScanning")
  }
  getScanFinishedStatus(jobId) {
    return this.getFinishedStatus(jobId, "WorkflowScanning")
  }
  getPrintFinishedStatus(jobId) {
    return this.getFinishedStatus(jobId, "Print")
  }
  getTransferringStatus (jobId, jobType) { // Change this name
    return this.getJobDetails(this.appSettings.deviceUrl, jobType, jobId)
      .then(value => {
        let jobState = this.getJobState(value.env, value.response)
        if (!(jobState.jobStateReasons == "Transferring" ||
            jobState.jobState == "Pending" ||
            jobState.jobState == "ProcessingStopped"  ||
            jobState.jobState == "PendingHeld")) {
          return this.$timeout(angular.noop, 2000).then(() => {
            return this.getTransferringStatus(jobId, jobType)
          })
        }
        else {
          return this.$q.resolve(jobState)
        }
      })
  }
  getFinishedStatus (jobId, jobType) {
    return this.getJobDetails(this.appSettings.deviceUrl, jobType, jobId)
      .then(value => {
        let jobState = this.getJobState(value.env, value.response)
        //HANDLE ProcessingStopped <-- status
        if (!(jobState.jobState == "Aborted" || jobState.jobState == "Canceled" || jobState.jobState == "Completed")) {
          return this.$timeout(angular.noop, 2000).then(() => {
            return this.getFinishedStatus(jobId, jobType)
          })
        }
        else {
          return this.$q.resolve(jobState)
        }
      })
  }
  getJobState (env, response) {
    var jobDetails = xrxJobMgmtParseGetJobDetails(response);

        var jobStateNode = xrxFindElement(jobDetails, ["JobInfo", "JobState"]);
        var jobState = xrxGetValue(jobStateNode);
        var jobStateFormatted = jobState.replace("Held", "").replace("Stopped", "");

        var jobStateReasonsNode = xrxFindElement(jobDetails, ["JobInfo", "JobStateReasons"]);
        var jobStateReasons = xrxGetValue(jobStateReasonsNode);

        //// TEMP: this is to show status on versa test
        this.appService.setScanStatusTemp({jobState, jobStateReasons})

        return {jobState, jobStateReasons}
  }
  getJobStatus (jobId) {
    //alert open
    return this.getJobDetails(this.appSettings.deviceUrl, "WorkflowScanning", jobId)
      .then(value => this.jobStatusSuccess(value.env, value.response))
  }
  getJobDetails(deviceUrl, jobType, jobId) {
    return new Promise((resolve, reject) => {
      xrxJobMgmtGetJobDetails(
        deviceUrl,
        jobType,
        jobId,
        (env, response) => resolve({env, response}),
        (env, response) => reject({method: 'Get Job Details', env, response}),
        10)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/jobStatus.service.js